import { Button } from "../button/button";
import { BigTitleStyled } from "../styles";
import { ContainerActions, ContainerModalStyled } from "./styles";
import { Box, Modal } from "@mui/material";

export const ModalV2 = ({
  children,
  isOpen,
  title,
  handleClose,
  actionButtons = [],
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      dismiss={{ enabled: false }}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(220, 215, 215, 0.25)",
        },
      }}
    >
      <ContainerModalStyled>
        {title && (
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={"1px solid #cbcbcb"}
            padding={"0 24px 24px 24px"}
            marginBottom={"24px"}
          >
            <BigTitleStyled>{title?.toUpperCase()}</BigTitleStyled>
            <Button
              onClick={handleClose}
              startIcon={"X"}
              type={"regular"}
              iconSize={24}
            />
          </Box>
        )}
        {children}
        {actionButtons?.length > 0 && (
          <ContainerActions>
            {actionButtons.map((button) => {
              const {
                label,
                onClick,
                disabled,
                tooltipLabel,
                type,
                startIcon,
              } = button;
              return (
                <Button
                  key={label}
                  label={label}
                  onClick={onClick}
                  disabled={disabled}
                  tooltipLabel={tooltipLabel}
                  type={type}
                  startIcon={startIcon}
                />
              );
            })}
          </ContainerActions>
        )}
      </ContainerModalStyled>
    </Modal>
  );
};
